module.exports = __webpack_public_path__ + "static/media/scarlet-macaw.c31791a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/scarlet-macaw.jpg
// module id = 794
// module chunks = 0